let it = {
    translations: {
        'Current Date':'Data Corrente',
        'Data relating to the average performance of the period': 'Dati relativi all\'andamento medio del periodo selezionato',
        'Active': 'Attivo',
        'Pause': 'Pausa',
        'Time': 'Tempo',
        "map-monitoring-points": "Mappa punti di monitoraggio",
        'data-relating-to-the-area': 'Dati relativi alla zona',
        'all-zones': 'Tutte le zone',
        'select-one-or-more zones': 'Seleziona una o più zone',
        'status-of-monitoring-points': 'Stato punti di monitoraggio',
        'critic': 'Critico',
        'warning': 'Attenzione',
        'filters': 'Filtri',
        'all': 'Tutti',
        'no-data-present': 'Nessun dato presente',
        'Real-time data': 'Dati in tempo reale',
        'temperature': 'Temperatura',
        'gis': 'GIS',
        "map-real-time": "Mappa dati in tempo reale",
        "map-animated": "Mappa storica animata",
        dashboard: 'Dashboard',
        home: 'Home',
        "status-sensors": "Stato punti di monitoraggio",
        "Alarm list": "Elenco allarmi",
        "data-sensors": "Dati Punti di Monitoraggio",
        "global": "Globale",
        "metrics": "Metriche",
        "management": "Amministrazione",
        "users": "Utenti",
        "monitoring-points": "Punti di monitoraggio",
        'humidity': 'Umidità',
        'illuminance': 'Illuminamento',
        'rainfall-intensity': 'Intensità Precipitazioni',
        'Rainfall intensity': 'Intensità precipitazioni',

        'Rainfall': 'Precipitazioni',
        'precipitation-peak': 'Picco precipitazioni',
        'wind-speed': 'Velocità vento',
        'wind-direction': 'Direzione vento',
        'atmospheric-pressure': 'Pressione atmosferica',
        'people-counter': 'Affollamento',
        'absent': 'Non presente',
        'high-decrement': 'Decremento Alto',
        'stable': 'Stabile',
        'variable': 'Variabile',
        'average-decrease': 'Decremento Medio',
        'low-decrement': 'Decremento Basso',
        'high-increment': 'Incremento Alto',
        'medium-increment': 'Incremento Medio',
        'low-increment': 'Incremento Basso',
        'Trend of the last 60 minutes': 'Andamento degli ultimi 60 minuti',
        'Average': 'Media',
        'Minimal': 'Minima',
        'Maxim': 'Massima',
        'All': 'Tutti',
        'Basic environmental monitoring': 'Monitoraggio ambientale base',
        'Advanced environmental monitoring': 'Monitoraggio ambientale avanzato',
        'environmental monitoring': 'Monitoraggio ambientale',
        'Camera': 'Camera',
        'WiFi': 'WiFi',
        'Gateway': 'Gateway',
        'Filter by component type': 'Filtra per tipo di componente',
        'Critical status monitoring points list': 'Punti di monitoraggio stato critico',
        'Attention status monitoring points list': 'Punti di monitoraggio stato attenzione',
        'Monitoring point list status OK': 'Punti di monitoraggio stato OK',
        'Address': 'Indirizzo',
        'View Alarms': 'Visualizza Allarmi',
        'Data not present': 'Dato non presente',
        'type': 'Tipo',
        'base': 'Base',
        'advanced': 'Avanzato',
        'add': 'Aggiungi',
        'Add sensor data': 'Aggiungi sensore',
        'Environmental Sensor ID': 'ID Sensore Ambientale',
        'Environmental Monitoring Status': 'Stato Monitoraggio Ambientale',
        'Camera status': 'Stato Camera',
        'Gateway status': 'Stato Gateway',
        'People counter status': 'Stato Affollamento',
        'WiFi status': 'Stato WiFi',
        'Show inactive': 'Mostra inattivi',
        'Show mutated': 'Mostra mutati',
        'There is no warning': 'Non è presente nessun allarme',
        'Component type': 'Tipo di componente',
        'Severity': 'Severità',
        'Type of alarm': 'Tipo di allarme',
        'Component ID': 'ID componente',
        'Creation date': 'Data creazione',
        'End date': 'Data fine',
        'Mute activated': 'Muto attivato',
        'Mute off': 'Muto disattivato',
        'Name': 'Nome',
        'Last name': 'Cognome',
        'Enabling': 'Abilitazione',
        'Confirmation': 'Conferma',
        'Role': 'Ruolo',
        'Add new user': 'Aggiungi nuovo utente',
        'Confirm password': 'Conferma Password',
        'Close': 'Chiudi',
        'User list': 'Lista utenti',
        'Add user': 'Aggiungi utente',
        'Modify user data': 'Modifica dati utente',
        'User data': 'Dati utente',
        'Edit': 'Modifica',
        'User role': 'Ruolo utente',
        'User Enablement': 'Abilitazione Utente',
        'Rows per page': 'Righe per pagina',
        'of': 'di',
        'Map monitoring points': 'Mappa punti di monitoraggio',
        'Base environmental station': 'Stazione ambientale base ',
        'Advanced environmental station': 'Stazione ambientale avanzata',
        'Intensity': 'Intensità',
        'Peak': 'Picco',
        'Wind': 'Vento',
        'Speed': 'Velocità',
        'Direction': 'Direzione',
        'Last 24 hours': 'Ultime 24 ore',
        'Select the date': 'Selezionare la data',
        'Start date and time': 'Data e ora di inizio',
        'End date and time': 'Data e ora di fine',
        'Animated historical map': 'Mappa storica animata',
        'Now': 'Ora',
        'Data relating to': 'Dati relativi a',
        'Data not available for selected options': 'Dati non disponibili per le opzioni selezionate',
        'No data for selected filters': 'Nessun dato per i filtri selezionati',
        'Wind speed and direction': 'Velocità e direzione vento',
        'Number of person': 'Numero di persone',
        'Confirmed': 'Confermato',
        'Not confirmed': 'Non Confermato',
        'Enabled': 'Abilitato',
        'Not Enabled': 'Non Abilitato',
        'Updated to': 'Ultimo aggiornamento',
        'All monitoring points': 'Tutti i punti di monitoraggio',
        'Select the station': 'Seleziona il punto di monitoraggio',
        'Elimination': 'Eliminazione',
        'Are you sure you want to proceed with the deletion?': 'Sei sicuro di voler procedere all\'eliminazione?',
        'Yes': 'Si',
        'Monitoring points list': 'Lista punti di monitoraggio',
        'Add station': 'Aggiungi stazione',
        'Connectivity type': 'Tipo di connettività',
        'Add new monitoring point': 'Aggiungi nuovo punto di monitoraggio',
        'Add monitoring point': 'Aggiungi punto di monitoraggio',

        'Station ID': 'ID stazione',
        'Latitude': 'Latitudine',
        'Longitude': 'Longitudine',
        'Description': 'Descrizione',
        'Environment monitoring': 'Monitoraggio ambiente',
        'Type of environmental monitoring': 'Tipo di monitoraggio ambientale',
        'Camera address': 'Indirizzo camera',
        'WiFi address': 'Indirizzo WiFi',
        'People counter sensor': 'Sensore di Affollamento',
        'Gateway ID': 'ID Gateway',
        'Serial Gateway': 'Seriale Gateway',
        'Gateway address': 'Indirizzo IP Gateway',
        'Gateway MAC': 'MAC Gateway',
        'Gateway internal address': 'Indirizzo IP interno Gateway',
        'Add Sensor': 'Aggiungi Sensore',
        'Edit People Counter Sensor ID': 'Modifica ID Sensore di Affollamento',
        'Sensor ID': 'ID Sensore',
        'Select the Metric': 'Selezionare la Metrica',
        'Air quality': 'Qualità dell\'aria',
        'Pressure': 'Pressione',
        'hour': 'Ora',
        'Humidity-percentage': 'Umidità (%)',

        'addData': 'Aggiungi dati',
        'addFilter': 'Aggiungi Filtro',
        'addLayer': 'Aggiungi Layer',
        'rowCount': 'Righe',

        'show animation': 'Mostra Animazione',
        'Component': 'Componente',
        'Details Environmental Sensor': 'Dettagli Sensore Ambientale',
        'Component status': 'Stato componenti',
        "No monitoring points in ok status": "Nessun punto di monitoraggio in stato ok",
        "No monitoring points in alert state": "Nessun punto di monitoraggio in stato di attenzione",
        "No monitoring points in critical state": "Nessun punto di monitoraggio in stato critico",
        "Date Validity": "Data Validità",
        'ID copied': 'ID copiato',
        'Modify data': 'Modifica dati',
        'Status': 'Stato',
        'Inactive': 'Inattivo',
        'Deactivate': 'Disattiva',
        'Activate': 'Attiva',
        'Model': 'Modello',
        'Sending interval': 'Intervallo di invio',
        'seconds': 'secondi',
        'AWS ID': 'ID AWS',
        'Internal address': 'Indirizzo interno',
        'Serial': 'Seriale',
        'Optic fiber': 'Fibra ottica',
        'years': 'anni',
        'None': 'Nessuno',
        'Enter your email address to receive the reset link': 'Inserire indirizzo email su cui ricevere il link per il reset',
        "Forgot password?": "Password dimenticata?",
        'Do you already have an account?': 'Hai già un account?',
        'Welcome': 'Benvenuto/a',
        "Enter your credentials to continue": "Inserisci le tue credenziali per continuare",
        'Account settings': 'Impostazioni Account',
        'Send email': 'Invia email',
        'Change Password': 'Modifica password',
        'Enter the new password': 'Inserire la nuova password',
        'An Error has occurred': 'Si è verificato un Errore',
        'Confirm registration': 'Conferma registrazione',
        "Failed to complete registration, invalid token!": "Impossibile completare la registrazione, token non valido!",
        "temperature_celsius": "Temperatura (°C)",
        'Atmospheric_pressure_symbol': 'Pressione atmosferica (hPa)',
        'People': 'Persone',
        'Sensors ID': 'ID Sensori',
        'W': 'O ',
        'WSW': 'OSO',
        'WNW': 'ONO',
        'NW': 'NO',
        'NNW': 'NNO',
        'SW': 'SO',
        'SSW': 'SSO',
        'Average direction': 'Direzione media',
        'Average speed': 'Velocità media',
        'absent-wind': 'Calmo',
        'Absent data': 'Dato assente',
        'Version': 'Versione',
        'Threshold of attention': 'Soglia di attenzione',
        'Historical data': 'Dati storici',
        'today': 'Oggi',
        'month': 'Mese',
        'Select date': 'Seleziona data',
        'Y Axis': 'Asse Y',
        'Moving Time Window': 'Muovi la finestra temporale',
        'Search': 'Ricerca',
        'User profile': 'Profilo utente',
        'Security': 'Sicurezza',
        'Profile Settings': 'Impostazioni Profilo',
        'Password required': 'Password obbligatoria',
        'Passwords do not match': 'Le password non coincidono',
        'Confirm password required': 'Conferma password obbligatoria',
        'Email required': 'Email obbligatoria',
        'Please enter a valid email': 'Inserire un\'email valida',
        'Role required': 'Ruolo obbligatorio',
        'Required address': 'Indirizzo obbligatorio',
        'Latitude required': 'Latitudine obbligatorio',
        'Longitude required': 'Longitudine obbligatorio',
        'Cluster required': 'Cluster obbligatorio',
        'Sensor required': 'Sensore obbligatorio',
        'Camera required': 'Camera obbligatorio',
        'Gateway id required': 'Gateway id obbligatorio',
        'Sensor id required': 'Sensor id obbligatorio',
        'Model required': 'Modello obbligatorio',
        'Id People Counter Sensor': 'ID Sensore di Affollamento obbligatorio',
        'Login': 'Accedi',
        'Management of environmental monitoring network and anthropic load': 'Gestione rete di monitoraggio ambientale e carico antropico',
        'Light': 'Chiaro',
        'Mode': 'Modalità',
        'Dark': 'Scuro',
        'Preset Color': 'Colore predefinito',
        'Live Customize': 'Personalizza tema',
        'Download the Archive': 'Scarica l\'Archivio',
        'with data relating to the monitoring point, taken every 10 minutes.': 'con i dati del giorno selezionato rilevati ogni 10 minuti, suddivisi per punto di monitoraggio',
        'Selected date': 'Data selezionata',
        'Download': 'Scarica',
        'No date selected': 'Nessuna data selezionata',
        'Archive not available for the selected day': 'Archivio non disponibile per il giorno selezionato.',
        'Confirm user': 'Conferma utente',
        'Monitoring point management': 'Gestione punto di monitoraggio',
        'CO2 level': 'Livello CO2',
        'PM 10 Level': 'Limiti Legali PM 10',
        "PM 2.5 Level": "Limiti Legali PM 2.5",
        "Heat Wave": "Ondata di calore",
        'Days': 'Giorni',
        'Previous day': 'Giornata precedente',
        'no hot wave': 'Nessuna ondata',
        'short wave': 'ondata breve',
        'long wave': 'ondata lunga',
        'In progress': 'In corso',
        'Not in progress': 'Non in corso',
        'Annual average': 'Media annuale',
        'Data not available': 'Dati non disponibili',
        'Acceptable': 'Accettabile',
        'Annual data': 'Dati annuali',
        'Previous day data': 'Dati giornata precedente',
        "Stats not available with 2 or more zones selected": "Insights non disponibili con 2 o più zone selezionate",
        "Stats not available with 2 or more zones selected and no station": "Insights non disponibili con 2 o più zone e nessun punto di monitoraggio selezionato",
        'Days with critical CO2 level': 'Giorni con livello CO2 critico',
        'Heat wave days': 'Giorni di ondata di calore',
        'Number waves': 'Numero ondate',
        'waves': 'ondate',
        'Legal limit': 'Limite legale',
        'Not passed': 'Non superato',
        'Passed': 'Superato',
        'OMS threshold': 'Soglia OMS',
        'Daily Limit': 'Limite Giornaliero',
        'from': 'da',
        'Not passed fem': 'Non superata',
        'Passed fem': 'Superata',
        'Average day': 'Media gior.',
        'Maximum day': 'Massima gior.',
        'pers.': 'pers.',
        'Hardware Version': 'Versione Hardware',
        'Software  Version': 'Versione Software ',
        'Present': 'Presente',
        'Select Month': 'Seleziona Mese',
        'Select Year': 'Seleziona Anno',
        'Select Year and Month': 'Seleziona Anno e Mese',
        'Download the archive containing the data collected every 10 minutes, divided by monitoring point': 'Scarica l\'archivio contenente i dati rilevati ogni 10 minuti, suddivisi per punto di monitoraggio',
        'Daily archive': 'Archivio Giornaliero',
        'Monthly Archive': 'Archivio Mensile',
        'unknown': 'sconosciuto',
        'No Options': 'Nessuna opzione',
        'Software Version': 'Versione Software',
        'Play': 'Riproduci',
        'Incremental Time Window': 'Finestra temporale incrementale',
    }
};

export default it;
